module.exports = {
	extends: [
		'/',
		'base',
		'tableSimple',
		'table'
	],

	config: {
		isSortable: true,
		lazyloadStepSize: 25,
		preventSortOfField: {
			tags: true
		},
		buttonContext: 'mailing',
		renderEmptyBeforReady: true,
		inline: true,
		maxNrOfExportElements: 500000
	},

	model: {
		resourceFilters: {
			order: [{
				fieldCode: 'running',
				direction: 'desc'
			},{
				fieldCode: 'sendDateTime',
				direction: 'desc'
			}]
		}
	},

	methods: {
		addEntity: function(entity){
			// add entity to dom if necessary
			if(this.config.isReady && this.model.$table){
				this.model.$table.append(this.include('./row', { config: this.config, resourceData: entity, model: this.model }))
			}
		},

		refreshViewData: function(){
			var self = this;
			self.performAndStoreAction(
				'refreshViewDataInEffect',
				self.prepareAction('refreshViewData'),
				true
			).then(function(){
				return self.refreshData();
			}).then(function(){
				getComponent('statusController').addPanel('status.done.dataRefreshed')
			});
		}
	},

	hooks: {
		attach: function($element, options){
			var self = this;
			if(!self.model.controller){
				self.closest('templates_global_newsletter_entity_controller', function(controller){
					self.model.controller = controller
				});
			}

			self.model.$table = $element.find('table');
		}
	},

	handlers: [{
		name: 'recordControllerResourcesModified',
		handle: function(callerComponent) {
			if(this.config.isReady){
				this.refreshData();
			}
		}
	}]
}